import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex flex-wrap gap-1 rounded-md border border-gray-200 p-1" }
const _hoisted_2 = ["aria-pressed", "onClick"]

import { ContactFilter, ContactHealthStatus } from '@/types';
import { useI18n } from 'vue-i18n';

interface HealthFilterOption {
    label: string;
    value: ContactHealthStatus | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactListFilters',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();



const emit = __emit;

const filters: HealthFilterOption[] = [
    { label: t('core.options.All'), value: null },
    { label: t('contact.timeline.stats.healthScore.healthy'), value: ContactHealthStatus.HEALTHY },
    {
        label: t('contact.timeline.stats.healthScore.attention'),
        value: ContactHealthStatus.ATTENTION,
    },
    { label: t('contact.timeline.stats.healthScore.atRisk'), value: ContactHealthStatus.AT_RISK },
];

const selectFilter = (health: ContactHealthStatus | null) => {
    emit('update:modelValue', { health });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(filters, (filter) => {
      return _createElementVNode("button", {
        key: filter.value ?? 'all',
        type: "button",
        "aria-pressed": _ctx.modelValue.health === filter.value,
        class: _normalizeClass(["rounded px-3 py-1.5 text-xs transition-colors", 
                _ctx.modelValue.health === filter.value
                    ? 'bg-primary text-white'
                    : 'text-gray-500 hover:bg-gray-200'
            ]),
        onClick: ($event: any) => (selectFilter(filter.value))
      }, _toDisplayString(filter.label), 11, _hoisted_2)
    }), 64))
  ]))
}
}

})